import { matcher, MatchType } from "@cdv/jazz-ui";
import View from "../ui/View";
import { Resource } from "../utils";
import Terms from "../Info/PersonalData";

export default matcher({ resource: "Gdpr" })
  .set(MatchType.View, View)
  .set(MatchType.View, Terms)
  .entries();
